export const COLORS = [
  '#132048',
  '#F26724',
  '#1E988A',
  '#006EB5',
  '#FAA21B',
  '#6E53A0',
  '#35499E',
  '#CE342A',
  '#383838',
  '#059BFF',
  '#FF8F5C',
  '#51C5CF',
  '#D8DFE1',
]

/**
 * Generates a random color from a series of preset options.
 */
export const randomColor = () => {
  const randomIndex = Math.random() * (COLORS.length - 1)
  const maxIndex = COLORS.length - 1
  const index = Math.round(Math.max(0, Math.min(randomIndex, maxIndex)))
  return COLORS[index]
}
